import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconColumnsStyle0 = gravityIconIndividualCss;

const GravityIconColumns = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '0163f577fb9f8a40eeeb09c2656f1f75cb9fbc3f', color: this.color, size: this.size }, h("svg", { key: '979c5dcad15bbc6d64d2ec4a758f2de556ce23d7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '8d940c1784b1c28ddaac1b93716547fa868f3e10', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-13Zm8 1.5h-3v11h3v-11Zm1.5 0v11h2.5v-11H14Zm-8.5 0H8v11H5.5v-11Z", fill: "currentColor" }))));
    }
};
GravityIconColumns.style = GravityIconColumnsStyle0;

export { GravityIconColumns as gravity_icon_columns };

//# sourceMappingURL=gravity-icon-columns.entry.js.map